var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30806 5.18306C3.55214 4.93898 3.94786 4.93898 4.19194 5.18306L7.8125 8.80362L11.4331 5.18306C11.6771 4.93898 12.0729 4.93898 12.3169 5.18306C12.561 5.42714 12.561 5.82286 12.3169 6.06694L8.25444 10.1294C8.13723 10.2467 7.97826 10.3125 7.8125 10.3125C7.64674 10.3125 7.48777 10.2467 7.37056 10.1294L3.30806 6.06694C3.06398 5.82286 3.06398 5.42714 3.30806 5.18306Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.d7812f7548172c44c9c61310b98c072e.svg";
export { ForwardRef as ReactComponent };